import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ========================================
// GLOBAL LOG INTERCEPTOR FOR DEBUGGING (dev only)
// ========================================
if (process.env.NODE_ENV === 'development') {
  const originalLog = console.log;
  const originalError = console.error;
  const originalWarn = console.warn;

  const captureLog = (type: 'log' | 'error' | 'warn', ...args: any[]) => {
    const timestamp = new Date().toISOString();
    const message = args.map(arg =>
      typeof arg === 'object' ? JSON.stringify(arg) : String(arg)
    ).join(' ');

    const logEntry = { timestamp, message, type };

    const existingLogs = JSON.parse(localStorage.getItem('debugLogs') || '[]');
    existingLogs.push(logEntry);

    // Keep last 200 logs
    const trimmedLogs = existingLogs.slice(-200);
    localStorage.setItem('debugLogs', JSON.stringify(trimmedLogs));
  };

  console.log = (...args: any[]) => {
    originalLog(...args);
    captureLog('log', ...args);
  };

  console.error = (...args: any[]) => {
    originalError(...args);
    captureLog('error', ...args);
  };

  console.warn = (...args: any[]) => {
    originalWarn(...args);
    captureLog('warn', ...args);
  };

  console.log('Debug logging enabled - visit /debug-logs to view all logs');
}
// ========================================

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
